import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { AlertService } from 'src/app/components/alert/alert.service';
import { PolicyService } from 'src/app/modules/policy/policy.service';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { IObjectKey } from 'src/app/modules/shared/models/objects';
import { ESubjectType, ISubject } from 'src/app/modules/shared/models/policy.model';
import { LoggerService } from 'src/app/services/logger.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { FormUtils } from 'src/app/utils/FormUtils';
import { IsvService } from '../../isv.service';
import { CommonUtils } from './../../../../utils/CommonUtils';
import { isv_search_form_keys, isv_search_form_template, isv_search_form_validators, searched_subject_keys } from './registry-search-isv.constants';

@Component({
  selector: 'app-registry-search-isv',
  templateUrl: './registry-search-isv.component.html',
  styleUrl: './registry-search-isv.component.scss'
})
export class RegistrySearchIsvComponent implements OnInit, OnDestroy {

  constructor(
    public dialogRef: MatDialogRef<RegistrySearchIsvComponent>,
    private readonly _isvService: IsvService,
    private readonly _alertService: AlertService,
    private readonly _spinnerService: SpinnerService,
    private readonly _policyService: PolicyService
  ) { }

  searchForm: FormGroup;
  searchFormKeys: IFormKey[] = CommonUtils.assign(isv_search_form_keys);

  searchedSubject: any;
  searchedSubjectRecap: ISubject = null;
  searchedSubjectRecapKeys: IObjectKey[] = searched_subject_keys;

  destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.searchForm = FormUtils.initFormGroupFromTemplate(isv_search_form_template, isv_search_form_validators);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSearchClick(): void {
    this._spinnerService.show();
    const taxCode = this.searchForm?.get('isvTaxCode')?.value;
    LoggerService.logInfo(this.constructor.name, 'onSearchClick', taxCode);
    this._isvService.searchSubjectByTaxCode(taxCode, this._policyService.contractNumber)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          LoggerService.logInfo(this.constructor.name, 'onSearchClick', response);
          this.searchedSubject = CommonUtils.checkAndGet(response, 'subjects[0]', null);
          this.setSubjectRecap();
          this._spinnerService.hide();
        },
        error: (err) => {
          LoggerService.logError(this.constructor.name, 'onSearchClick', err);
          this._alertService.openErrorMessage('Errore durante la ricerca del soggetto', err);
          this._spinnerService.hide();
        }
      });
  }

  reset(): void {
    LoggerService.logInfo(this.constructor.name, 'reset');
    this.searchForm?.reset();
  }

  close(action: string): void {
    LoggerService.logInfo(this.constructor.name, 'close');
    switch (action) {
      case 'CONFIRM':
        this.dialogRef.close(this.searchedSubject);
        break;
      case 'CLOSE':
        default:
        this.dialogRef.close(null);
        break;
    }
  }

  setSubjectRecap(): void {
    if (this.searchedSubject) {
      this.searchedSubjectRecap = {
        ndg: null,
        name: this.searchedSubject.firstName,
        surname: this.searchedSubject.lastName,
        birthDate: this.searchedSubject.birthAddress?.DataNascita,
        taxCode: this.searchedSubject.fiscalCode,
        vatCode: null,
        businessName: null,
        type: ESubjectType.PF
      }
    }
  }

  get subjectTitle(): string {
    return this.searchedSubjectRecap
      ? `${this.searchedSubjectRecap.name} ${this.searchedSubjectRecap.surname}`
      : null;
  }

}
